import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthService } from '../../services/Auth/AuthService';
import { CircularProgress, Box, Typography } from '@mui/material';

const SigninCallback: React.FC = () => {
    const navigate = useNavigate();
    const [error, setError] = useState<string | null>(null);
    const handledRef = useRef(false);

    useEffect(() => {
        if (handledRef.current) return;
        handledRef.current = true;

        const handleCallback = async () => {
            try {
                // Handle signin callback
                console.log('url to complete auth: ' + window.location);
                const authService = await AuthService.theInstance();
                await authService.completeAuthentication(window.location.href);
                
                // Clear the URL parameters
                window.history.replaceState({}, window.document.title, window.location.origin);
                
                // Redirect to home
                navigate('/');
            } catch (err) {
                console.error('Authentication callback error:', err);
                setError(err instanceof Error ? err.message : 'Authentication failed');
            }
        };

        handleCallback();
    }, [navigate]);

    if (error) {
        return (
            <Box 
                display="flex" 
                flexDirection="column" 
                justifyContent="center" 
                alignItems="center" 
                minHeight="100vh"
            >
                <Typography variant="h5" color="error" gutterBottom>
                    Authentication Error
                </Typography>
                <Typography variant="body1">{error}</Typography>
            </Box>
        );
    }

    return (
        <Box 
            display="flex" 
            flexDirection="column" 
            justifyContent="center" 
            alignItems="center" 
            minHeight="100vh"
        >
            <CircularProgress />
            <Typography variant="body1" sx={{ mt: 2 }}>
                Completing authentication...
            </Typography>
        </Box>
    );
};

export default SigninCallback;
